import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { withClearInteraction } from '../../helpers/styled';
import { isNumber } from '../../helpers';

var getAlignment = function getAlignment(input) {
  var alignmentList = ['left', 'right', 'center'];
  return alignmentList.includes(input) ? input : 'left';
};

var getTableCell = function getTableCell(p) {
  var _ref = p || {},
      width = _ref.width,
      styles = _ref.styles,
      alignment = _ref.alignment,
      altStyle = _ref.altStyle,
      coreTheme = _ref.coreTheme;

  return css(["width:", ";padding:", "px 0;@media (min-width:", "){padding:", "px;}text-align:", ";position:relative;&.checkbox{padding:", "px ", "px;", ";@media (min-width:", "){padding:", "px;}}&.radio{padding:", "px ", "px;", ";@media (min-width:", "){padding:0 ", "px;}}&::after{position:absolute;border-bottom:1px solid ", ";height:1px;width:100%;content:'';bottom:0;right:0;}&:first-child{padding-left:", "px;@media (min-width:", "){padding-left:", "px;}&::after{width:calc(100% - ", "px);left:auto;right:0;@media (min-width:", "){width:calc(100% - ", "px);}}}&:last-child{padding-right:", "px;@media (min-width:", "){padding-right:", "px;}&::after{width:calc(100% - ", "px);left:0;right:auto;@media (min-width:", "){width:calc(100% - ", "px);}}}&:only-child{&::after{width:calc(100% - ", "px);left:", "px;right:", "px;}}", ""], width ? isNumber(width) ? width + 'px' : width : 'auto', coreTheme.space_2, coreTheme.brk_xs, coreTheme.space_6, alignment ? getAlignment(alignment) : 'left', coreTheme.space_2, coreTheme.space_4, altStyle && "vertical-align: top", coreTheme.brk_xs, coreTheme.space_6, coreTheme.space_2, coreTheme.space_4, altStyle && "vertical-align: top", coreTheme.brk_xs, coreTheme.space_6, coreTheme.cl_ter_l5, coreTheme.space_4, coreTheme.brk_xs, coreTheme.space_6, coreTheme.space_4, coreTheme.brk_xs, coreTheme.space_6, coreTheme.space_4, coreTheme.brk_xs, coreTheme.space_6, coreTheme.space_4, coreTheme.brk_xs, coreTheme.space_6, coreTheme.space_8, coreTheme.space_4, coreTheme.space_4, styles);
};

export var TableContainer = withTheme(styled.div.withConfig({
  displayName: "style__TableContainer",
  componentId: "sc-1vllvt4-0"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return css(["width:100%;overflow-x:auto;box-shadow:", ";border-radius:", ";@media (min-width:", "){border-radius:", ";}"], coreTheme.sd_size_1, coreTheme.rad_xs, coreTheme.brk_xs, coreTheme.rad_xl);
}));
export var Table = styled.table.withConfig({
  displayName: "style__Table",
  componentId: "sc-1vllvt4-1"
})(["width:100%;display:table;table-layout:auto;border-collapse:separate;border-spacing:0;text-align:left;"]);
export var Headth = withTheme(styled.th.withConfig({
  displayName: "style__Headth",
  componentId: "sc-1vllvt4-2"
})(function (p) {
  return css(["background:", ";font-weight:500;", " &::after{border-bottom:none;}"], p.coreTheme.cl_ter_l6, getTableCell(p));
}));
export var HeadContent = styled.div.withConfig({
  displayName: "style__HeadContent",
  componentId: "sc-1vllvt4-3"
})(["display:inline-flex;align-items:center;user-select:", ";cursor:", ";"], function (p) {
  return p.sortable ? 'none' : 'auto';
}, function (p) {
  return p.sortable ? 'pointer' : 'initial';
});
export var SortWrapper = withTheme(styled.div.withConfig({
  displayName: "style__SortWrapper",
  componentId: "sc-1vllvt4-4"
})(function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return css(["margin-right:", "px;@media (min-width:", "){margin-left:", "px;}"], coreTheme.space_1, coreTheme.brk_xs, coreTheme.space_4);
}));
export var HeadSorter = withClearInteraction(withTheme(styled.div.withConfig({
  displayName: "style__HeadSorter",
  componentId: "sc-1vllvt4-5"
})(["display:inline-flex;flex-direction:column;align-items:center;"])), 10, 3);
export var tr = withTheme(styled.tr.withConfig({
  displayName: "style__tr",
  componentId: "sc-1vllvt4-6"
})(function (_ref4) {
  var coreTheme = _ref4.coreTheme;
  return css([":hover{background-color:", ";}&:last-child > td::after{border-bottom:none;}&.active{background-color:", ";}"], coreTheme.table.backgroundColor.hover, coreTheme.table.backgroundColor.active);
}));
export var td = withTheme(styled.td.withConfig({
  displayName: "style__td",
  componentId: "sc-1vllvt4-7"
})(function (p) {
  return css(["", ""], getTableCell(p));
}));
export var MobileContainer = styled.div.withConfig({
  displayName: "style__MobileContainer",
  componentId: "sc-1vllvt4-8"
})(["display:flex;"]);
export var MobileTitleTextWrapper = styled.div.withConfig({
  displayName: "style__MobileTitleTextWrapper",
  componentId: "sc-1vllvt4-9"
})(function (p) {
  return css(["&::after{content:':';}", ""], p.styles);
});
export var MobileDataTextWrapper = styled.div.withConfig({
  displayName: "style__MobileDataTextWrapper",
  componentId: "sc-1vllvt4-10"
})(function (p) {
  return css(["", ""], p.styles);
});